/**
 * Synchronization configuration constants
 *
 * These values control sync retry behavior and auto-sync debouncing.
 * They are centralized here for easy adjustment and testing.
 */
export const SYNC_CONFIG = {
  /**
   * Maximum number of retry attempts for failed syncs
   */
  maxRetries: 5,

  /**
   * Initial retry delay in milliseconds (1 second)
   * Used as the base for exponential backoff calculation
   */
  initialRetryDelay: 1000,

  /**
   * Maximum retry delay in milliseconds (60 seconds)
   * Caps the exponential backoff to prevent excessive delays
   */
  maxRetryDelay: 60_000,

  /**
   * Auto-sync debounce delay in milliseconds (5 seconds)
   * Prevents rapid successive sync attempts when network comes back online
   */
  autoSyncDebounceMs: 5000,
} as const;
